var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTz({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 344.276V97.103a8.829 8.829 0 0 1 8.828-8.828h379.586L0 344.276z",
    fill: "#73af00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 167.724v247.172a8.829 8.829 0 0 1-8.828 8.828H123.586l388.414-256z",
    fill: "#4173cd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512 172.702V97.103a8.829 8.829 0 0 0-8.828-8.828H383.139L0 339.298v75.598a8.829 8.829 0 0 0 8.828 8.828h120.033L512 172.702z",
    fill: "#ffe15a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M512 141.047V97.103a8.829 8.829 0 0 0-8.828-8.828h-71.718L0 370.953v43.944a8.829 8.829 0 0 0 8.828 8.828h71.718L512 141.047z",
    fill: "#464655"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTz);
export default __webpack_public_path__ + "static/media/tz.10b9398ac5e71819ebd662786d64a403.svg";
export { ForwardRef as ReactComponent };